import { homeConstant } from "../../../../standard/constants/homeConstant";
import { LocalStorageService } from "../../../../services";

const initialState = {
  step: 1,
  step1Data: {},
  step2Data: {},
  step3Data: {},
  step4Data: {},
};

export default function home(state = initialState, action) {
  switch (action.type) {
    case homeConstant.GET_STARTED_STEP:
      return {
        ...state,
        step: action.payload.step,
        step1Data: action.payload,
      };

    case homeConstant.CHOOSE_ASSESSMENTS_STEP:
      return {
        ...state,
        step: action.payload.step,
        step2Data: action.payload.data,
      };

    case homeConstant.CUSTOMIZE_STEP:
      return {
        ...state,
        step: action.payload.step,
        step3Data: action.payload.data,
      };

    case homeConstant.CONFIGURE_LAUNCH_STEP:
      return {
        ...state,
        step: 4,
        step4Data: action.payload.data,
      };

    case homeConstant.PREVIOUS_STEP:
      return {
        step: action.payload.step,
        step1Data: state.step1Data,
        step2Data: state.step2Data,
        step3Data: state.step3Data,
        step4Data: state.step4Data,
      };

    case homeConstant.FINAL_STEP:
      return {
        ...state,
        step: action.payload.step,
      };

    case homeConstant.ASSESSMENT_REPORT:
      return {
        ...state,
        step: action.payload.step,
      };

    case homeConstant.BACK_TO_HOME:
      return {
        ...state,
        step: action.payload.step,
        clearAll: true,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    // Adding Campaigns Types

    case homeConstant.ADD_CAMPAIGN_NAME_REQUEST:
      return {
        ...state,
        step: 5,
        message: action.payload.message,
      };

    case homeConstant.ADD_CAMPAIGN_NAME:
      return {
        ...state,
        step: 5,
        message: action.payload.message,
        bucketName: action.payload.bucketName,
        campaignId: action.payload.campaignId,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.ADD_CAMPAIGN_NAME_ERROR:
      return {
        ...state,
        step: 5,
        message: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    case homeConstant.SEND_SINGLE_INVITE_REQUEST:
      return {
        ...state,
        loading: true,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    case homeConstant.SEND_SINGLE_INVITE:
      return {
        ...state,
        loading: false,
        succesMessage: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.SEND_SINGLE_INVITE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.SEND_BULK_INVITE_REQUEST:
      return {
        ...state,
        bulkloading: true,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.SEND_BULK_INVITE:
      return {
        ...state,
        bulkloading: false,
        bulkSuccesMessage: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.SEND_BULK_INVITE_ERROR:
      return {
        ...state,
        bulkloading: false,
        message: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    case homeConstant.SEND_SUPPORT_EMAIL_REQUEST:
      return {
        ...state,
        supportLoading: true,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.SEND_SUPPORT_EMAIL:
      return {
        ...state,
        supportLoading: false,
        supportMessage: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    case homeConstant.SEND_SUPPORT_ERROR:
      return {
        ...state,
        supportLoading: false,
        errorMessage: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    case homeConstant.GET_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        temploading: true,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    case homeConstant.GET_SUCCESS_EMAIL_TEMPLATE:
      return {
        ...state,
        temploading: false,
        succesTemplateMessage: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };

    case homeConstant.GET_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        temploading: false,
        message: action.payload.message,
        step1Data: {},
        step2Data: {},
        step3Data: {},
        step4Data: {},
      };
    default:
      return state;
  }
}
